import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

const HEAD_FONT = { fontFamily: '"IBM Plex Sans", Inter, sans-serif' };
const BODY_FONT = { fontFamily: 'Inter, "IBM Plex Sans", sans-serif' };

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-black" style={BODY_FONT}>
      <nav className="border-b border-black/10 bg-white/70 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            data-testid="privacy-back-btn"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm text-black/70 hover:text-black"
          >
            <ArrowLeft size={14} weight="bold" /> Home
          </button>
          <span className="text-sm font-black tracking-tight" style={HEAD_FONT}>Founderboard</span>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="privacy-page">
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-black/60 mb-4">Legal</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1] mb-6" style={HEAD_FONT}>
          Privacy Policy
        </h1>
        <p className="text-sm text-black/50 mb-12">Last updated: February 2026</p>

        <div className="space-y-8 text-base text-black/75 leading-relaxed">
          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>1. Information we collect</h2>
            <p>
              Founderboard collects information you provide directly — name, email, phone, company details, funding history, and any documents you upload (pitch decks, monthly updates). We also collect basic usage analytics (page views, clicks) to improve the product.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>2. How we use it</h2>
            <p>
              Your data powers the product features you signed up for — portfolio tracking, MoIC calculation, AI Coach, program applications, and transactional emails. We never sell user data. We use Anthropic's Claude to power AI features; conversations are sent to Anthropic under their privacy terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>3. Sharing</h2>
            <p>
              When a startup accepts an investment from a VC fund, relevant metrics (revenue, runway, equity %) become visible to that fund. Public program applications are visible to the program owner. Otherwise, your data stays within your workspace and is never shared with third parties without your consent.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>4. Security</h2>
            <p>
              We use industry-standard encryption (TLS in transit, AES-256 at rest), JWT authentication, and short-lived password-reset tokens. Files are served only to authorised users in the same workspace or portfolio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>5. Your rights</h2>
            <p>
              You can request data export, correction, or deletion at any time by emailing{' '}
              <a href="mailto:sid@founderboard.io" className="underline hover:text-black">sid@founderboard.io</a>. Account deletion removes all your personal data within 30 days, except where retention is required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>6. Contact</h2>
            <p>
              Questions about this policy?{' '}
              <a href="mailto:sid@founderboard.io" className="underline hover:text-black">sid@founderboard.io</a>
            </p>
          </section>
        </div>
      </article>
    </div>
  );
}
